import { Button, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../redux/hooks';
import { setResetLoadSchedule } from '../redux/slice/schdules/scheduleSlice';

function StepSchedules({ step, loadingCreate, loadingUpdate }: any) {
  const stepsCount = 5;
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const handleBack = (step: any) => {
    switch (step) {
      case 1:
        navigate('/bus-management/schedules');
        dispatch(setResetLoadSchedule());
        break;
      case 2:
        navigate('/bus-management/schedules/segment');
        break;
      case 3:
        navigate('/bus-management/schedules/locations');
        break;
      case 4:
        navigate('/bus-management/schedules/settings');
        break;
      case 5:
        navigate('/bus-management/schedules/agent-seats');
        break;
      default:
        break;
    }
  };
  return (
    <div className="block-header-segment d-flex items-center justify-between">
      <div>
        <Typography.Text className="fw-500 fs-14">{`Bước ${step} / 5`}</Typography.Text>
        <div className="step-block">
          {[...Array(stepsCount)].map((_, index) => (
            <div key={index} className={`${step === index + 1 || step > index + 1 ? 'active' : ''} __item`}></div>
          ))}
        </div>
      </div>
      <div className="d-flex items-center">
        <Button
          htmlType="button"
          onClick={() => handleBack(step)}
          className="continue d-flex items-center justify-center border-none"
        >
          Quay lại
        </Button>
        {step === 5 ? (
          <Button
            htmlType="submit"
            className="btn-success continue d-flex items-center justify-center text-center"
            style={{ minWidth: 'unset' }}
            disabled={loadingCreate || loadingUpdate}
          >
            <span className="text-center">Lưu</span>
          </Button>
        ) : (
          <Button htmlType="submit" className="btn-success continue d-flex items-center justify-center text-center">
            <span className="text-center">Tiếp tục</span>
          </Button>
        )}
      </div>
    </div>
  );
}

export default StepSchedules;
